import React, { useContext, useEffect, useState } from 'react';
import AppContext from "./AppContext"
import { Typography, Row, Card, message, Button, Table, Radio, Col, List, Input, Space, Select, Modal, Spin } from "antd";
import { onGetAllTasks } from '../Controller/Management/TaskManagement';
import { GetTranslation } from '../Models/shared/general';
import { Redirect, useNavigate } from "react-router-dom";
import Highlighter from 'react-highlight-words';
import { ArrowRightOutlined, SearchOutlined, UserAddOutlined, HomeTwoTone, ContactsTwoTone, HomeOutlined, ContactsOutlined } from '@ant-design/icons';
import moment, { duration } from 'moment';
import { parse } from 'uuid';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { onGetAttendancelistbyuser } from '../Controller/Attendance';
import Avatar from 'antd/lib/avatar/avatar';
import randomColor from "randomcolor";

import { onSearchUser, onRequestAddUser, getUserbyId, onGetUserContact, onRequestAproveUser, onRequestRemoveUser } from "../Controller/Management/UserProf_Ctrl"
import { ListConsumer } from 'antd/lib/list';
// //====== IMPORT CSS LIB =========
// import "antd/dist/antd.css";


export default function Dashboard(props) {
    const global = useContext(AppContext);
    const userid = global.UserIdentity.userid;
    const username = global.UserIdentity.username;
    const dispatch = useDispatch();


    const [datasource, setDataSource] = useState([]);
    const [datasourceAtten, setDataSourceAtten] = useState([]);
    const [datasourceTABLE, setDataSourceTABLE] = useState([]);
    const [datasourceCONTACT, setDataSourceCONTACT] = useState([]);

    const [datasourceCONTACTDisplay, setDataSourceCONTACTDisplay] = useState([]);
    const [tempdatasourceCONTACT, setTempDataSourceCONTACT] = useState([]);

    const [approveAction, setApproveAction] = useState("")
    const [removeAction, setRemoveAction] = useState("")
    const [searchAction, setSearchAction] = useState("")
    const userlang = navigator.language || navigator.userLanguage;

    //==== TASK MANAGEMENT =====
    const [instructed, setInstructed] = useState(0);
    const [requested, setRequested] = useState(0);
    const [unread, setUnread] = useState(0);
    const [waitApproval, setWaitApproval] = useState(0);
    const [progress, setProgress] = useState(0);
    const [unverify, setUnverify] = useState(0);
    const [subordinary, setSubordinary] = useState(0);
    const [onhold, setOnhold] = useState(0);

    const [listloading1, setlistloading1] = useState(false)

    const [attendanceTitle, setattendanceTitle] = useState("");
    const [attendanceTime, setattendanceTime] = useState("");
    const [attendanceColor, setattendanceColor] = useState("");
    const [attendanceFontColor, setattendanceFontColor] = useState("");
    const [searchresult, setsearchresult] = useState("")
    const [searchkeyword, setsearchkeyword] = useState("")
    const [dashboardview, setdashboardview] = useState("dashboard")

    const [instrucrtedColor, setinstrucrtedColor] = useState("");
    const [instrucrtedFontColor, setinstrucrtedFontColor] = useState("");
    const [instrucrtedunreadcount, setinstrucrtedunreadcount] = useState(0);

    const [requestedColor, setrequestedColor] = useState("");
    const [requestedFontColor, setrequestedFontColor] = useState("");
    const [requestedunreadcount, setrequestedunreadcount] = useState(0);

    const [showtable, setshowtable] = useState("This Week")

    const [showSELFthisweek, setSELFshowthisweek] = useState([]);
    const [showSELFnextweek, setSELFshownextweek] = useState([]);
    const [showSELFlastweek, setSELFshowlastweek] = useState([]);
    const [showSELFunplan, setSELFunplan] = useState([]);

    const [showOTHthisweek, setOTHshowthisweek] = useState([]);
    const [showOTHnextweek, setOTHshownextweek] = useState([]);
    const [showOTHlastweek, setOTHshowlastweek] = useState([]);
    const [showOTHunplan, setOTHunplan] = useState([]);

    const [search, setSearch] = useState({ Text: "", Column: "" })
    const [shouuserdata, setuserdata] = useState([]);
    const [taskstatus, settaskstatus] = useState([])


    const [ModaladdContact, setModaladdContact] = useState(false);

    const { Title } = Typography;

    const getColumnSearchProps = (dataIndex, title) => ({

        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>

                <Input

                    autoFocus={true}
                    placeholder={`Search ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => {
                        setSelectedKeys(e.target.value ? [e.target.value] : [])
                        //handleSearch(e.target.value, confirm, dataIndex)
                    }}
                    onKeyDown={e => {
                        if (e.key === 'Enter') {
                            //setSelectedKeys(e.target.value ? [e.target.value] : [])
                            handleSearch(e.target.value, confirm, dataIndex)
                        }
                    }}
                    style={{ width: 200, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        data-reset='reset'
                        type="link"
                        onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? "crimson" : undefined }} />,

        onFilter: (value, record) =>
            record[dataIndex]
                ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
                : '',

        render: (text) =>
            search.Column === dataIndex ?
                (
                    <Highlighter
                        highlightStyle={{ backgroundColor: "gold", padding: 0 }}
                        searchWords={[search.Text]}
                        autoEscape
                        textToHighlight={text ? text.toString() : ''}
                    />
                )
                : (
                    text
                ),


    });
    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm({ closeDropdown: false });
        setSearch({
            Text: selectedKeys,
            Column: dataIndex,
        });

    };
    const handleReset = clearFilters => {
        clearFilters({ closeDropdown: false });
        setSearch({ Column: search.Column, Text: '' });
    };
    function compareValues(key, order = 'asc') {
        return function innerSort(a, b) {
            if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
                return 0;
            }

            const varA = (typeof a[key] === 'string')
                ? a[key].toUpperCase() : a[key];
            const varB = (typeof b[key] === 'string')
                ? b[key].toUpperCase() : b[key];

            let comparison = 0;
            if (varA > varB) {
                comparison = 1;
            } else if (varA < varB) {
                comparison = -1;
            }
            return (
                (order === 'desc') ? (comparison * -1) : comparison
            );
        };
    }

    const clickstyle = { cursor: 'pointer', width: '100%' }

    var colSELFdata = [


        {
            title: 'Task Description',
            dataIndex: 'taskname',
            key: 'taskname',
            ...getColumnSearchProps('taskname', 'Task Description'),
            render: text => <a href="/TaskManagement" onClick={() => onSearchSELF(text)} style={clickstyle}>{text}</a>,

        },
        {
            title: 'Assign By',
            dataIndex: 'createdby',
            key: 'createdby',
            ...getColumnSearchProps('createdby', 'Assign By'),
        },
        {
            title: 'Plan Start Date',
            dataIndex: 'plansdate',
            key: 'plansdate',

        },
        {
            title: 'Plan End Date',
            dataIndex: 'planedate',
            key: 'planedate',

        },
        {
            title: 'Status',
            dataIndex: 'currentstatus',
            key: 'currentstatus',

        },
        {
            title: 'Check List',
            dataIndex: 'checklist',
            key: 'checklist',

        },
        {
            title: 'Time Left',
            dataIndex: 'timeleft',
            key: 'timeleft',
            sorter: (a, b) => a.timeleft.length - b.timeleft.length,
            render(text, record) {
                return {
                    props: {
                        style: { color: record.minutesdiff > 0 ? "red" : "black" }
                    },
                    children: <div>{text}</div>
                };
            }
        },

    ]

    var colOTHdata = [


        {
            title: 'Task Description',
            dataIndex: 'taskname',
            key: 'taskname',
            ...getColumnSearchProps('taskname', 'Task Description'),
            render: text => <a href="/TaskManagement" onClick={() => onSearchSELF(text)} style={clickstyle}>{text}</a>,

        },
        {
            title: 'Assign By',
            dataIndex: 'createdby',
            key: 'createdby',
            ...getColumnSearchProps('createdby', 'Assign By'),

        },
        {
            title: 'Assign to',
            dataIndex: 'assignto',
            key: 'assignto',
            ...getColumnSearchProps('assignto', 'Assign To'),
        },
        {
            title: 'Plan Start Date',
            dataIndex: 'plansdate',
            key: 'plansdate',

        },
        {
            title: 'Plan End Date',
            dataIndex: 'planedate',
            key: 'planedate',

        },
        {
            title: 'Status',
            dataIndex: 'currentstatus',
            key: 'currentstatus',

        },
        {
            title: 'Check List',
            dataIndex: 'checklist',
            key: 'checklist',

        },
        {
            title: 'Time Left',
            dataIndex: 'timeleft',
            key: 'timeleft',
            sorter: (a, b) => a.timeleft.length - b.timeleft.length,
            render(text, record) {
                return {
                    props: {
                        style: { color: record.minutesdiff < 0 ? "black" : "red" }
                    },
                    children: <div>{text}</div>
                };
            }
        },

    ]

    const onRefreshAttendance = () => {
        return Promise.all([onGetAttendancelistbyuser({ username: userid })])
            .then(([val]) => {
                let result = val?.data[0];
                if (result != undefined) {
                    // Type = Att then go to punchout, set datasource
                    let type = result.type;

                    if (type == "Att") {
                        //===== IF GOT RESULT ON DESC =========
                        let punchout = result.punchout;
                        let punchin = result.punchin;
                        let dts = result.dts;
                        let timenow = moment().set({ hour: 0, minute: 0, second: 0 }).unix();
                        //  console.log("timenow",timenow)
                        //  console.log("dts",result.dts)

                        if (punchout == undefined || punchout == "") {
                            setDataSourceAtten(result);
                            setattendanceColor("#1890ff")
                            setattendanceTime(moment.unix(result.punchin).format("DD/MMM-HH:mm"))
                            setattendanceTitle(GetTranslation(userlang, "Attedance") + " - " + GetTranslation(userlang, "Punch In"))
                            setattendanceFontColor("white")
                        }
                        else if (dts == timenow) {

                            setattendanceColor("#00ed64")
                            setattendanceTime(moment.unix(result.punchout).format("DD/MMM-HH:mm"))
                            setattendanceTitle(GetTranslation(userlang, "Attedance") + " - " + GetTranslation(userlang, "Completed"))
                            setattendanceFontColor("black")
                        }
                        else {

                            setattendanceColor("#ff4d4f")
                            setattendanceTime("")
                            setattendanceTitle(GetTranslation(userlang, "Attedance") + " - " + GetTranslation(userlang, "Pending"))
                            setattendanceFontColor("white")
                        }

                    }
                    else {
                        //=== CHECK DATE ====
                        let dts = result.dts;
                        let timenow = moment().set({ hour: 0, minute: 0, second: 0 }).unix();
                        //=== IF SAME TIME =====(MEANS TODAY  AL, EL, MC)
                        if (dts == timenow) {
                            setDataSourceAtten(result);
                            setattendanceColor("#1890ff")
                            setattendanceTime("AL Or MC Today")
                            setattendanceTitle("")
                        }
                    }
                }

            })

            .catch(err => {

            });
    }

    function onRefreshInstructed(val) {
        // return Promise.all([onGetAttendancelistbyuser({ username: userid})])
        // .then(([val]) => { 

        // console.log("val >>>>",val)
        let result = val;
        let cbunread = 0;
        let count = 0;
        if (result != undefined) {
            // Type = Att then go to punchout, set datasource


            val.forEach(function (items) {

                if (items.createdby == userid) {
                    if (items.status == 0) {
                        if (items.cbunread == 1) {
                            cbunread = 1
                            count++
                            // console.log("items >>>>",items)
                        }
                    }

                }

            })
            if (cbunread == 1) {


                setinstrucrtedColor("#ff4d4f")
                setinstrucrtedFontColor("white")
            }
            else {
                setinstrucrtedColor("white")

                setinstrucrtedFontColor("black")
            }


        }

        setinstrucrtedunreadcount(count)
        console.log("count >>>", count)

    }

    function onRefreshRequested(val) {
        // return Promise.all([onGetAttendancelistbyuser({ username: userid})])
        // .then(([val]) => { 


        let result = val;
        let atunread = 0;
        let count = 0;
        if (result != undefined) {
            // Type = Att then go to punchout, set datasource


            val.forEach(function (items) {

                if (items.assignto == userid) {
                    if (items.status == 0) {
                        if (items.atunread == 1) {
                            //console.log("request items >>",items)
                            atunread = 1
                            count++
                        }
                    }

                }

            })
            if (atunread == 1) {


                setrequestedColor("#ff4d4f")
                setrequestedFontColor("white")
            }
            else {
                setrequestedColor("white")

                setrequestedFontColor("black")
            }


        }

        setrequestedunreadcount(count)
        console.log("count >>>", count)

    }

    // })

    // .catch(err => {

    // });




    //===== USE EFFECT =======
    useEffect(() => {
        onRefresh();
        onRefreshAttendance();
        onRefreshContactlist();
    }, []);


    useEffect(() => {
        if (datasource.length > 0) {
            //==== INSTRUCTED ====
            let instructed = datasource.filter(x => x.status == 0 && (x.createdby == userid && x.assignto != userid)).length;
            setInstructed(instructed);

            //==== REQUESTED =====
            let requested = datasource.filter(x => x.status == 0 && (x.assignto == userid)).length;
            setRequested(requested);

            //==== UNREAD =====
            let unread = datasource.filter(x => (x.assignto == userid && x.atunread == 1) || (x.createdby == userid && x.cbunread == 1)).length;
            setUnread(unread);

            //===== WAITING FOR APPROVAL =====
            // let waitApprove = datasource.filter(x => x.status == 1 && ((x.assignto == userid && x.createdby != userid) || (x.createdby == userid && x.assignto == userid && x.reportto != ""))).length;
            let waitApprove = datasource.filter(x => x.status == 1 && ((x.assignto == userid && x.createdby != userid) || (x.createdby == userid && x.assignto == userid))).length;
            setWaitApproval(waitApprove);

            //===== PROGRESS ======
            let progress = datasource.filter(x => x.status == 0).length;
            setProgress(progress);

            //====== UNVERIFY =====
            // let unverify    = datasource.filter(x => x.status == 1 && ((x.assignto != userid && x.createdby == userid) || ((x.assignto == x.createdby) && x.reportto == userid))).length;
            let unverify = datasource.filter(x => x.status == 1 && ((x.assignto != userid && x.createdby == userid) || (x.assignto == x.createdby))).length;
            setUnverify(unverify);

            //===== SUBORDINARY =====
            // let subordinary = datasource.filter(x => x.reportto == userid && x.createdby != userid && x.status == 0).length;
            let subordinary = datasource.filter(x => x.createdby != userid && x.status == 0).length;
            setSubordinary(subordinary)

            //===== ONHOLD =====
            let onhold = datasource.filter(x => x.status == 2).length;
            setOnhold(onhold)

            //buildDashboardData(datasource)

        }
    }, [datasource])

    useEffect(() => {
        if (datasourceTABLE.length > 0) {
            //==== SELF THIS WEEK ====
            let selfthisweek = datasourceTABLE.filter(x => x.weekstatus == "This Week" && x.assignto == userid && x.status != '9');

            setSELFshowthisweek(selfthisweek.sort(compareValues('minutesdiff', 'asc')));

            //==== SELF NEXT WEEK ====
            let selfnextweek = datasourceTABLE.filter(x => x.weekstatus == "Next Week" && x.assignto == userid && x.status != '9');

            setSELFshownextweek(selfnextweek.sort(compareValues('minutesdiff', 'asc')));

            //==== SELF LAST WEEK ====
            let selflastweek = datasourceTABLE.filter(x => x.weekstatus == "Last Week" && x.assignto == userid && x.status != '9');

            setSELFshowlastweek(selflastweek.sort(compareValues('minutesdiff', 'desc')));

            //==== SELF UNPLAN WEEK ====
            let selfunplan = datasourceTABLE.filter(x => x.weekstatus == "Not Planned" && x.assignto == userid && x.status == '0');

            setSELFunplan(selfunplan.sort(compareValues('taskname', 'asc')));

            //==== OTHER THIS WEEK ====
            let oththisweek = datasourceTABLE.filter(x => x.weekstatus == "This Week" && x.assignto != userid && x.status != '9');

            setOTHshowthisweek(oththisweek.sort(compareValues('minutesdiff', 'asc')));

            //==== OTHER NEXT WEEK ====
            let othnextweek = datasourceTABLE.filter(x => x.weekstatus == "Next Week" && x.assignto != userid && x.status != '9');

            setOTHshownextweek(othnextweek.sort(compareValues('minutesdiff', 'asc')));

            //==== OTHER LAST WEEK ====
            let othlastweek = datasourceTABLE.filter(x => x.weekstatus == "Last Week" && x.assignto != userid && x.status != '9');

            setOTHshowlastweek(othlastweek.sort(compareValues('minutesdiff', 'desc')));

            //==== OTHER UNPLAN WEEK ====
            let othunplan = datasourceTABLE.filter(x => x.weekstatus == "Not Planned" && x.assignto != userid && x.status == '0');

            setOTHunplan(othunplan.sort(compareValues('taskname', 'asc')));
        }
    }, [datasourceTABLE])

    //==== SUMMARY TABLE ===


    const tabledatasourceSELF = () => {
        if (showtable == "This Week") {
            return (
                <Table
                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colSELFdata}
                    pagination={true}
                    dataSource={showSELFthisweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'SELF On-going Task (This Week)'}>
                </Table>
            )
        }
        else if (showtable == "Last Week") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colSELFdata}
                    pagination={true}
                    dataSource={showSELFlastweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'SELF On-going Task (Last Week)'}>


                </Table>
            )
        }

        else if (showtable == "Next Week") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colSELFdata}
                    pagination={true}
                    dataSource={showSELFnextweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'SELF On-going Task (Next Week)'}>


                </Table>
            )
        }

        else if (showtable == "Unplan") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colSELFdata}
                    pagination={true}
                    dataSource={showSELFunplan}
                    rowKey=''
                    bordered={true}
                    title={() => 'SELF On-going Task (Unplanned))'}>


                </Table>
            )
        }

    }

    const tabledatasourceOTH = () => {
        if (showtable == "This Week") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colOTHdata}
                    pagination={true}
                    dataSource={showOTHthisweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'Member On-going Task (This Week)'}>


                </Table>
            )
        }
        else if (showtable == "Last Week") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colOTHdata}
                    pagination={true}
                    dataSource={showOTHlastweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'Member On-going Task (Last Week)'}>


                </Table>
            )
        }

        else if (showtable == "Next Week") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colOTHdata}
                    pagination={true}
                    dataSource={showOTHnextweek}
                    rowKey=''
                    bordered={true}
                    title={() => 'Member On-going Task (Next Week)'}>


                </Table>
            )
        }

        else if (showtable == "Unplan") {
            return (
                <Table

                    style={{ whiteSpace: 'break-spaces' }}
                    size={'small'}
                    columns={colOTHdata}
                    pagination={true}
                    dataSource={showOTHunplan}
                    rowKey=''
                    bordered={true}
                    title={() => 'Member On-going Task (Unplanned)'}>


                </Table>
            )
        }

    }

    //==== TASK MANAGEMENT ===
    const onRefresh = () => {
        onGetAllTasks({ createdby: userid, assignto: userid, reportto: userid })
            .then((val) => {
                setDataSource(val.data);
                onRefreshInstructed(val.data);
                onRefreshRequested(val.data);
                return val;
            })
            .catch(err => {
                message.error(GetTranslation(userlang, "Cannot get data"));
            });

    }

    const onRefreshContactlist = () => {
        onGetUserContact({ userid: userid })
            .then((val) => {
                if (val.data.length > 0) {
                   
                    // Count the number of objects where cstatus is 0
                    const countCStatusZero = val.data.reduce((count, obj) => {
                        if (obj.cstatus === 0 && obj.crequest === 0) {
                            count += 1;
                        }
                        return count;
                    }, 0);

                    localStorage.setItem("pendingcontact", countCStatusZero)
                    setDataSourceCONTACT(val.data)
                    setDataSourceCONTACTDisplay(val.data)
                }
                else
                {
                    localStorage.setItem("pendingcontact", 0)
                }

                return val;
            })
            .catch(err => {
                message.error(GetTranslation(userlang, "Cannot get data"));
            });
    }

    function buildDashboardData(xData) {
        var newlist = [];
        var obj = {};
        var count = 1;

        xData.forEach(function (items) {

            obj = {}
            obj["indexno"] = count
            obj["status"] = items.status.toString().trim()
            obj["assignto"] = (items.assignto) ? items.assignto.toString().trim() : ''
            obj["createdby"] = (items.createdby) ? items.createdby.toString().trim() : ''
            obj["currentstatus"] = (items.currentstatus) ? items.currentstatus.toString().trim() : ''
            var deadline1 = (items.deadline) ? moment.unix(items.deadline).format("DD/M ddd h:mm a") : ''
            obj["deadline"] = deadline1
            var extenddeadline1 = (items.extenddeadline) ? moment.unix(items.extenddeadline).format("DD/M ddd h:mm a") : ''
            obj["extenddeadline"] = extenddeadline1
            var plansdate1 = (items.plansdate) ? moment.unix(items.plansdate).format("DD/M ddd h:mm a") : ''
            obj["plansdate"] = plansdate1
            var planedate1 = (items.planedate) ? moment.unix(items.planedate).format("DD/M ddd h:mm a") : ''
            obj["planedate"] = planedate1
            obj["reportto"] = (items.reportto) ? items.reportto.toString().trim() : ''
            obj["taskname"] = (items.taskname) ? items.taskname.toString().trim() : ''
            obj["startweeknum"] = items.plansdate ? moment.unix(items.plansdate).week() : -1
            obj["startendnum"] = items.planedate ? moment.unix(items.planedate).week() : -1

            let checklist = items.checklist
            var progress = 0

            if (checklist != undefined) {
                let truecount = 0
                progress = 0
                checklist.forEach(function (xdata) {
                    if (xdata.status == true) {
                        truecount += 1
                    }
                }
                )

                if (checklist.length != 0) {

                    progress = (truecount / checklist.length) * 100
                    progress = Math.round(progress * 100) / 100

                    obj["checklist"] = `${truecount}/${checklist.length}`
                    //obj["checklist"] = `${progress}%`

                }

                else {
                    obj["checklist"] = ""
                }

            }
            else {
                obj["checklist"] = ""
            }

            if (obj["startweeknum"] == -1) {
                obj["weekstatus"] = "Not Planned"
            }

            else if (obj["startweeknum"] == moment().week()) {
                obj["weekstatus"] = "This Week"
            }
            else if (obj["startweeknum"] > moment().week()) {
                obj["weekstatus"] = "Next Week"
            }
            else if (obj["startweeknum"] < moment().week()) {
                if (items.status.toString().trim() == "0") {
                    obj["weekstatus"] = "This Week"
                }
                else {
                    if (obj["startendnum"] >= moment().week()) {
                        obj["weekstatus"] = "This Week"
                    }
                    else if (obj["startendnum"] < moment().week()) {
                        obj["weekstatus"] = "Last Week"
                    }

                }

            }

            let remainingday = "";
            let daydiff = 0;
            let hoursdiff = 0;
            let minutesdiff = 0;

            if (items.status.toString().trim() == "1") {
                remainingday = "Completed"
            }
            else if (items.status.toString().trim() == "3") {
                remainingday = "Submited"
            }
            else if (items.status.toString().trim() == "0") {
                if (extenddeadline1 != "") {
                    daydiff = moment().diff(moment.unix(items.extenddeadline), 'days');
                    hoursdiff = moment().diff(moment.unix(items.extenddeadline), 'hours');
                    minutesdiff = moment().diff(moment.unix(items.extenddeadline), 'minutes');

                    //===== DIFFERENCE BETWEEN DAY ======
                    if (parseInt(minutesdiff) < 0) {
                        if (parseInt(hoursdiff) < 0) {
                            if (parseInt(daydiff) < 0) {
                                remainingday = daydiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${daydiff * -1} ${daydiff * -1 == 1 ? GetTranslation(userlang, "day") : GetTranslation(userlang, "days")}`}`;
                            }
                            else {
                                remainingday = hoursdiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${hoursdiff * -1} ${hoursdiff * -1 == 1 ? GetTranslation(userlang, "hour") : GetTranslation(userlang, "hours")}`}`;
                            }
                        }
                        else {
                            remainingday = minutesdiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${minutesdiff * -1} ${minutesdiff * -1 == 1 ? GetTranslation(userlang, "minute") : GetTranslation(userlang, "minutes")}`}`;
                        }
                    }
                    else {
                        if (parseInt(hoursdiff) > 0) {
                            if (parseInt(daydiff) > 0) {
                                remainingday = daydiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${daydiff} ${daydiff == 1 ? GetTranslation(userlang, "day") : GetTranslation(userlang, "days")}`}`;
                            }
                            else {
                                remainingday = hoursdiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${hoursdiff} ${hoursdiff == 1 ? GetTranslation(userlang, "hour") : GetTranslation(userlang, "hours")}`}`;
                            }
                        }
                        else {
                            remainingday = minutesdiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${minutesdiff} ${minutesdiff == 1 ? GetTranslation(userlang, "minute") : GetTranslation(userlang, "minutes")}`}`;
                        }
                    }
                }

                else if (deadline1 != "") {
                    daydiff = moment().diff(moment.unix(items.deadline), 'days');
                    hoursdiff = moment().diff(moment.unix(items.deadline), 'hours');
                    minutesdiff = moment().diff(moment.unix(items.deadline), 'minutes');



                    //===== DIFFERENCE BETWEEN DAY ======
                    if (parseInt(minutesdiff) < 0) {
                        if (parseInt(hoursdiff) < 0) {
                            if (parseInt(daydiff) < 0) {
                                remainingday = daydiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${daydiff * -1} ${daydiff * -1 == 1 ? GetTranslation(userlang, "day") : GetTranslation(userlang, "days")}`}`;
                            }
                            else {
                                remainingday = hoursdiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${hoursdiff * -1} ${hoursdiff * -1 == 1 ? GetTranslation(userlang, "hour") : GetTranslation(userlang, "hours")}`}`;
                            }
                        }
                        else {
                            remainingday = minutesdiff == "" ? "" : `${`${GetTranslation(userlang, "")} ${minutesdiff * -1} ${minutesdiff * -1 == 1 ? GetTranslation(userlang, "minute") : GetTranslation(userlang, "minutes")}`}`;
                        }
                    }
                    else {
                        if (parseInt(hoursdiff) > 0) {
                            if (parseInt(daydiff) > 0) {
                                remainingday = daydiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${daydiff} ${daydiff == 1 ? GetTranslation(userlang, "day") : GetTranslation(userlang, "days")}`}`;
                            }
                            else {
                                remainingday = hoursdiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${hoursdiff} ${hoursdiff == 1 ? GetTranslation(userlang, "hour") : GetTranslation(userlang, "hours")}`}`;
                            }
                        }
                        else {
                            remainingday = minutesdiff == "" ? "" : `${`${GetTranslation(userlang, "-")} ${minutesdiff} ${minutesdiff == 1 ? GetTranslation(userlang, "minute") : GetTranslation(userlang, "minutes")}`}`;
                        }
                    }
                }
                else {
                    remainingday = ""
                }

            }

            obj["timeleft"] = remainingday
            obj["daydiff"] = daydiff
            obj["hoursdiff"] = hoursdiff
            obj["minutesdiff"] = minutesdiff

            newlist.push(obj);
            count++;
        }
        );
        setDataSourceTABLE(newlist)
        //    console.log('datasource',datasource)
        //console.log("week",moment().week())
        //  console.log('newlist',newlist)
        return newlist;
    }
    const onChangeRadio = e => {
        //console.log('radio checked', e.target.value);
        setshowtable(e.target.value)

    };

    const create_card_style_compact = {
        borderRadius: "10px",
        display: "flex",
        //minHeight: "100%",
        alignItems: "center",
        justifyContent: "center",
        //fontSize: "3.7em",

    }
    const gridStyle = {
        width: '14.285%', textAlign: 'center', borderRadius: "10px",

    };
    const gridStyle1 = {
        textAlign: 'center', borderRadius: "10px",

    };

    const onSearchSELF = async (val) => {

        // localStorage.removeItem("taskfilter")  
        // localStorage.removeItem("tasktype")   
        // localStorage.setItem("taskname",val)
        // localStorage.setItem("taskpage",2)   

        localStorage.setItem("action", "")
        // var data1 = {}
        // data1 = {taskname:val}        
        // dispatch({ type: "dashboard2", payload: data1 });


    };

    const onPress1 = async (val) => {

        // localStorage.setItem("taskfilter","instructed")  
        // localStorage.setItem("tasktype",0)   
        // localStorage.removeItem("taskname")     
        // localStorage.setItem("taskpage",2)

        localStorage.setItem("action", "")
        //    var data1 = {}
        //    data1 = {taskfilter:"instructed",tasktype:0,taskname:undefined}  

        //    dispatch({ type: "dashboard1", payload: data1 });



    };
    const onPress2 = async (val) => {

        // localStorage.setItem("taskfilter","requested")  
        // localStorage.setItem("tasktype",0)   

        // localStorage.removeItem("taskname")  
        // localStorage.setItem("taskpage",2)   

        localStorage.setItem("action", "")
        //   var data1 = {}
        //   data1 = {taskfilter:"requested",tasktype:0}         
        //   dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress3 = async (val) => {

        // localStorage.setItem("taskfilter","all")  
        // localStorage.setItem("tasktype",0)    

        // localStorage.removeItem("taskname")  
        // localStorage.setItem("taskpage",2)  

        localStorage.setItem("action", "")
        //    var data1 = {}
        //    data1 = {taskfilter:"all",tasktype:0}          
        //    dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress4 = async (val) => {

        // localStorage.setItem("taskfilter","all")  
        // localStorage.setItem("tasktype",1)  

        // localStorage.removeItem("taskname") 
        // localStorage.setItem("taskpage",2)   

        localStorage.setItem("action", "")
        //  var data1 = {}
        //  data1 = {taskfilter:"all",tasktype:1}          
        //  dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress5 = async (val) => {

        // localStorage.setItem("taskfilter","all")  
        // localStorage.setItem("tasktype",0)    

        // localStorage.removeItem("taskname")    
        // localStorage.setItem("taskpage",2)

        localStorage.setItem("action", "")
        //  var data1 = {}
        //  data1 = {taskfilter:"all",tasktype:0}          
        //  dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress6 = async (val) => {

        // localStorage.setItem("taskfilter","all")  
        // localStorage.setItem("tasktype",1.1)  

        // localStorage.removeItem("taskname")    
        // localStorage.setItem("taskpage",2)   

        localStorage.setItem("action", "")
        //   var data1 = {}
        //   data1 = {taskfilter:"all",tasktype:1.1}        
        //   dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress7 = async (val) => {

        // localStorage.setItem("taskfilter","subordinary")  
        // localStorage.setItem("tasktype",0)   

        // localStorage.removeItem("taskname")   
        // localStorage.setItem("taskpage",2) 

        localStorage.setItem("action", "")
        // var data1 = {}
        // data1 = {taskfilter:"subordinary",tasktype:0}          
        // dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPress8 = async (val) => {

        // localStorage.setItem("taskfilter","all")  
        // localStorage.setItem("tasktype",2)   

        // localStorage.removeItem("taskname")   
        // localStorage.setItem("taskpage",2) 
        localStorage.setItem("action", "")
        // var data1 = {}
        // data1 = {taskfilter:"subordinary",tasktype:0}          
        // dispatch({ type: "dashboard1", payload: data1 });


    };
    const onPressNewTask = async (val) => {

        //   localStorage.setItem("taskfilter","instructed")  
        // localStorage.setItem("tasktype",0)   
        // localStorage.removeItem("taskname")     
        // localStorage.setItem("taskpage",2)
        // console.log("val data>>>", val)
        // localStorage.setItem("action", "opennewtask")
        // if (val != undefined && val != "") {
        //     localStorage.setItem("taskuserid", val)
        // }

        // var data1 = {}
        // data1 = {taskfilter:"subordinary",tasktype:0}          
        // dispatch({ type: "dashboard1", payload: data1 });


    };

    const data = [
        {

            title: 'Attendance',
            content: `${attendanceTitle}`,
            content1: `${attendanceTime}`,
            content2: <a href="/Attendance"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `${attendanceColor}`,
            fontcolor: `${attendanceFontColor}`


        },
        {

            title: 'NewTask',
            content: `${GetTranslation(userlang, "New Task")}`,
            content1: ``,
            content2: <a href="/TaskManagement"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `white`,
            fontcolor: `black`


        },
        {
            title: 'Reminder',
            content: `${GetTranslation(userlang, "Reminder")}`,
            content1: ``,
            content2: <a href="/Reminder"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `white`,
            fontcolor: `black`

        },
        {

            title: 'Title 1',
            content: `${GetTranslation(userlang, "Instructed")}`,
            content1: `${instructed}  `,
            content2: <a href="/TaskManagement"><Button><ArrowRightOutlined /></Button></a>,
            // content3:`${instrucrtedunreadcount}`,
            backgroundColor: `${instrucrtedColor}`,
            fontcolor: `${instrucrtedFontColor}`


        },
        {
            title: 'Title 2',
            content: `${GetTranslation(userlang, "Requested")}`,
            content1: `${requested} `,
            content2: <a href="/TaskManagement"><Button ><ArrowRightOutlined /></Button></a>,
            backgroundColor: `${requestedColor}`,
            fontcolor: `${requestedFontColor}`

        },
        // {
        //   title: 'Title 3',
        //   content: `${GetTranslation(userlang, "Unread")}`,
        //   content1: `${unread} `,
        //   content2:<a href="/TaskManagement"><Button onClick={onPress3}><ArrowRightOutlined /></Button></a>,
        //   backgroundColor: `white`,
        //   fontcolor:`black`

        // },
        {
            title: 'Title 4',
            content: `${GetTranslation(userlang, "Waiting for Approval")}`,
            content1: `${waitApproval} `,
            content2: <a href="/TaskManagement"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `white`,
            fontcolor: `black`

        },
        {
            title: 'Title 5',
            content: `${GetTranslation(userlang, "Progress")}`,
            content1: `${progress} `,
            content2: <a href="/TaskManagement"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `white`,
            fontcolor: `black`

        },
        {
            title: 'Title 6',
            content: `${GetTranslation(userlang, "Unverified")}`,
            content1: `${unverify} `,
            content2: <a href="/TaskManagement"><Button><ArrowRightOutlined /></Button></a>,
            backgroundColor: `white`,
            fontcolor: `black`

        },
        // {
        //     title: 'Title 7',
        //     content: `${GetTranslation(userlang, "Subordinate")}`,
        //     content1: `${subordinary} `,
        //     content2:<a href="/TaskManagement"><Button onClick={onPress7}><ArrowRightOutlined /></Button></a>,
        //     backgroundColor: `white`,
        //     fontcolor:`black`

        // },

        // {
        //     title: 'Title 8',
        //     content: `${GetTranslation(userlang, "On Hold")}`,
        //     content1: `${onhold} `,
        //     content2:<a href="/TaskManagement"><Button onClick={onPress8}><ArrowRightOutlined /></Button></a>,
        //     backgroundColor: `white`,
        //     fontcolor:`black`

        // },

    ];


    return (
        <>

            <Row justify="space-around">
                <Title level={1}>Dashboard</Title>
            </Row>

            <>
                <Col span={22} offset={1}>
                    {/* <div style={{textAlign: 'center'}}>
                <Title>
                    <HomeTwoTone style={{marginRight:"20px"}} onClick={(e) => setdashboardview("dashboard")}></HomeTwoTone>
                  
                    <ContactsOutlined onClick={(e) => setdashboardview("contactlist")}></ContactsOutlined>
                </Title>
             </div>
                <br/> */}
                    <List
                        grid={{
                            gutter: 16,
                            xs: 2,
                            sm: 2,
                            md: 4,
                            lg: 4,
                            xl: 6,
                            xxl: 6,
                        }}
                        dataSource={data}
                        renderItem={item => (
                            <List.Item>
                                <Card
                                    bodyStyle={{ backgroundColor: item.backgroundColor, border: 0, color: item.fontcolor }}
                                    size='small' hoverable style={gridStyle1}>{item.content}<br></br><h2 style={{ color: item.fontcolor }}>{item.content1}{item.content2}
                                        {/* <br/>
                    {item.content == "Instructed"? instrucrtedunreadcount +" Unread"
                    :
                    `${item.content == "Requested"? instrucrtedunreadcount +" Unread"
                    :
                    ""}`
                    } */}
                                    </h2></Card>
                            </List.Item>
                        )}
                    />
                </Col>
                <p></p>
            </>
            {/* <Row>
                <Col offset={5}>
                <Radio.Group onChange={onChangeRadio} value={showtable} >
                <Radio value={'Unplan'}>Unplan</Radio>
                <Radio value={'Last Week'}>Last Week</Radio>
                    <Radio value={'This Week'}>This Week</Radio>
                    <Radio value={'Next Week'}>Next Week</Radio>
                </Radio.Group> 
                </Col>               
            </Row>
            <p></p>
            <Row>
             
                <Col span={22} offset={1}>
                    {tabledatasourceSELF()}
                </Col>
                <Row> </Row>
                <br></br>
                <Col span={22} offset={1}>
                    {tabledatasourceOTH()}
                </Col>
                </Row> */}


        </>
    )
}